import React, { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { reviewDeletedAction } from '../../../redux/actions/orderActions'
import { uploadToCloudinary } from '../../../utils/uploadToCloudinary'
import store from '../../../store'
const ReviewDeletedForm = ({ order }) => {




    const dispatch = useDispatch()




    const [refund_image_proof_url, setRefund_image_proof_url] = useState('')
    const [refund_image_proof_url_preview, setRefund_image_proof_url_preview] = useState('')

    const [isRefunded, setIsRefunded] = useState(null)
    const [markPmCommission, setMarkPmCommission] = useState(null)



    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (setImage, setPreview) => (e) => {
        e.preventDefault();

        const file = e.dataTransfer.files[0];

        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }
    };

    const handleFileChange = (setImage, setPreview) => (e) => {
        const file = e.target.files[0];

        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }
    };


    const displayID = String((order?.id)).padStart(6, '0');



    const handleSubmit = async (e) => {
        e.preventDefault();


        if (isRefunded === null && !order?.refund_image_proof_url) {
            toast.error("Please fill in all required fields");
            return;
        }


        if (isRefunded && !refund_image_proof_url) {
            toast.error("Please fill in all required fields");
            return;
        }


        if (markPmCommission === null) {
            toast.error("Please fill in all required fields");
            return;
        }



        try {

            let refundProofURL = null
            // ✅ START (add this)
            if (refund_image_proof_url) {
                store.dispatch({ type: "UPLOAD_START" });

                // 1️⃣ Upload image
                refundProofURL = await uploadToCloudinary(
                    refund_image_proof_url,
                    "orders",
                    1, // current
                    1  // total
                );
            }



            // 2️⃣ Send to backend
            const data = {
                refund_image_proof_url: refundProofURL,
                order_id: order.id,
                mark_pm_commission: markPmCommission,
            };

            dispatch(reviewDeletedAction(data))




            // ✅ END (add this)
            store.dispatch({ type: "UPLOAD_END" });

        } catch (err) {
            store.dispatch({ type: "UPLOAD_RESET" });

            toast.error("Image upload failed. Please Check your Internet Connection and then try again.");
        }





    }

    const handleReset = () => {
        refund_image_proof_url('')
        refund_image_proof_url_preview('')


    }






    return (
        <Fragment>
            <form action="" className="w-full lg:w-[50%] flex  gap-[1vmax] flex-wrap justify-between" onSubmit={handleSubmit}>
                <div className="flex w-full ">
                    <span className='text-[1.5vmax] lg:text-[1.1vmax] font-bold text-blue-500' >Order ID : &nbsp; </span>
                    <span className='text-gray-500' >{displayID}</span>
                </div>
                <div className="flex w-full mb-[1vmax]">
                    <span className='text-[1.5vmax] lg:text-[1.1vmax] font-bold text-green-600' >
                        Order Number: &nbsp;
                    </span>
                    <span className='text-gray-500 ' >{order?.order_number}</span>
                </div>
                {!order?.refund_image_proof_url &&
                    <div className="">
                        <span>Is the order refunded?  <span className='text-red-500'>*</span></span>
                        <br />
                        <div className="flex gap-[1vmax] my-[1vmax]">
                            <button className={`text-[1vmax]  border-2 border-green-600 text-green-600 font-bold p-[0.5vmax_1vmax] rounded-lg hover:scale-[0.95] ${isRefunded === true ? "bg-green-600 text-white" : ""}`}
                                onClick={() => setIsRefunded(true)}
                                type="button"
                            >
                                Yes
                            </button>
                            <button className={`text-[1vmax]  border-2 border-red-600 text-red-600 font-bold p-[0.5vmax_1vmax] rounded-lg hover:scale-[0.95] ${isRefunded === false ? "bg-red-600 text-white" : ""}`}
                                onClick={() => setIsRefunded(false)}
                                type="button"
                            >
                                No
                            </button>
                        </div>



                        {
                            isRefunded &&
                            <>
                                <span>Refund Proof  <span className='text-red-500'>*</span></span>
                                <br />
                            </>
                        }
                    </div>
                }
                {isRefunded && !order.refund_image_proof_url &&
                    <>
                        <div className="flex justify-between flex-wrap lg:flex-nowrap  flex-col-reverse lg:flex-row w-full mt-[0.5vmax]">

                            {/* Left side preview box */}
                            {refund_image_proof_url_preview &&
                                <div className="w-[60%] mx-auto mt-[3vmax] lg:mt-[0vmax] lg:mx-0 lg:w-[48%] p-[0.5vmax] flex-center  overflow-hidden border border-gray-200 rounded-[1vmax]">
                                    <img
                                        src={refund_image_proof_url_preview}
                                        alt="Preview"
                                        className="w-full h-full object-contain"
                                    />
                                </div>
                            }

                            {/* Right side upload area */}
                            <div className={`w-[100%] ${refund_image_proof_url_preview ? "lg:w-[48%]" : "lg:w-[100%]"}`}>
                                <div
                                    className="w-[100%]  border-[0.15vmax] border-dashed border-gray-300 rounded-[0.7vmax] flex-center cursor-pointer hover:bg-gray-50 transition-all duration-200 py-[0.5vmax]  h-full "
                                    onDrop={handleDrop(
                                        setRefund_image_proof_url,
                                        setRefund_image_proof_url_preview
                                    )}
                                    onDragOver={handleDragOver}
                                    onClick={() => document.getElementById("refundproofInput").click()}
                                >
                                    <input
                                        id="refundproofInput"
                                        type="file"
                                        accept="image/png, image/jpeg"
                                        onChange={handleFileChange(setRefund_image_proof_url, setRefund_image_proof_url_preview)}
                                        className="hidden"
                                    />
                                    <p className="text-center font-[400] text-[1vmax] leading-[2vmax] text-gray-600">
                                        <br />
                                        <i className="fa-regular fa-image text-[3vmax]"></i>
                                        <br />
                                        Drop your image here, or{" "} <br />
                                        <strong className='text-[var(--primary)]' >click to upload</strong>.<br />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </>

                }


                <div className="">
                    <span>is PM Commission Encluded?  <span className='text-red-500'>*</span></span>
                    <br />
                    <div className="flex gap-[1vmax] my-[1vmax]">
                        <button className={`text-[1vmax]  border-2 border-green-600 text-green-600 font-bold p-[0.5vmax_1vmax] rounded-lg hover:scale-[0.95] ${markPmCommission === true ? "bg-green-600 text-white" : ""}`}
                            onClick={() => setMarkPmCommission(true)}
                            type="button"
                        >
                            Yes
                        </button>
                        <button className={`text-[1vmax]  border-2 border-red-600 text-red-600 font-bold p-[0.5vmax_1vmax] rounded-lg hover:scale-[0.95] ${markPmCommission === false ? "bg-red-600 text-white" : ""}`}
                            onClick={() => setMarkPmCommission(false)}
                            type="button"
                        >
                            No
                        </button>
                    </div>
                </div>

                <div className="flex justify-start w-full mt-[2vmax] gap-[2vmax]">
                    <button className="text-gray-500 border-2 border-gray-500 hover:bg-gray-500 hover:text-white p-[0.6vmax_1.5vmax] rounded-lg" onClick={handleReset} type='button' >Reset</button>
                    <button className="text-white bg-[image:var(--gradient-2)] p-[0.6vmax_1.5vmax] rounded-lg hover:scale-[0.9]" type='submit' >Submit</button>
                </div>

            </form>
        </Fragment>
    )
}

export default ReviewDeletedForm